"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Bubble = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _Feedback = require("../Feedback");
var _clsx4 = _interopRequireDefault(require("clsx"));
var _bubble_left4x = _interopRequireDefault(require("../../assets/images/bubble_left@4x.png"));
var _bubble_right4x = _interopRequireDefault(require("../../assets/images/bubble_right@4x.png"));
var _loading_gray_slow = _interopRequireDefault(require("../../assets/images/loading_gray_slow.gif"));
var _loading_circle = _interopRequireDefault(require("../../assets/images/loading_circle.svg"));
var _image_failure = _interopRequireDefault(require("../../assets/images/image_failure.png"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}

// import bubbleWhiteImage from '../../assets/images/bubble_white_reverse.png';
// import bubbleOrangeImage from '../../assets/images/bubble_orange.png';
var Bubble = function Bubble(props) {
  var _clsx2, _props$feedback;
  var className = props.className,
    _props$block = props.block,
    block = _props$block === void 0 ? false : _props$block,
    _props$from = props.from,
    from = _props$from === void 0 ? 'left' : _props$from,
    _props$bubbleType = props.bubbleType,
    bubbleType = _props$bubbleType === void 0 ? 'default' : _props$bubbleType,
    _props$hideBubbleAngl = props.hideBubbleAngle,
    hideBubbleAngle = _props$hideBubbleAngl === void 0 ? false : _props$hideBubbleAngl,
    _props$customized = props.customized,
    customized = _props$customized === void 0 ? false : _props$customized,
    _props$status = props.status,
    status = _props$status === void 0 ? 'default' : _props$status,
    _props$onStatusClick = props.onStatusClick,
    onStatusClick = _props$onStatusClick === void 0 ? function (status) {
      console.log('status', status);
    } : _props$onStatusClick,
    children = props.children;
  var getRealType = function getRealType() {
    var isLeftOrDefault = from === 'left' || props.bubbleType === 'default';
    var isText = bubbleType === 'text';
    return isText ? 'text' : isLeftOrDefault ? 'default' : 'primary';
  };
  var bubbleAngleElement = {
    default: /*#__PURE__*/_react.default.createElement("img", {
      src: _bubble_left4x.default
    }),
    primary: /*#__PURE__*/_react.default.createElement("img", {
      src: _bubble_right4x.default
    }),
    text: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)
  }[getRealType()];
  var statusElemnt = {
    default: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null),
    typing: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null),
    loading: /*#__PURE__*/_react.default.createElement("img", {
      src: _loading_circle.default,
      className: (0, _getPrefixCls.getPrefixCls)('bubble-status__loading'),
      onClick: function onClick() {
        return onStatusClick('loading');
      }
    }),
    error: /*#__PURE__*/_react.default.createElement("img", {
      src: _image_failure.default,
      className: (0, _getPrefixCls.getPrefixCls)('bubble-status__error'),
      onClick: function onClick() {
        return onStatusClick('error');
      }
    })
  }[status];
  var showStatus = (0, _react.useMemo)(function () {
    return ['error', 'loading'].includes(status);
  }, [status]);
  if (getRealType() === 'text') {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx4.default)((0, _getPrefixCls.getPrefixCls)('bubble'), (0, _getPrefixCls.getPrefixCls)('bubble-text'), className)
    }, children);
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx4.default)((0, _getPrefixCls.getPrefixCls)('bubble'), (0, _getPrefixCls.getPrefixCls)("bubble-".concat(from)), className)
  }, customized ? children : /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx4.default)((0, _getPrefixCls.getPrefixCls)('bubble-container'), (0, _defineProperty2.default)({}, (0, _getPrefixCls.getPrefixCls)('bubble-container__block'), block))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx4.default)((0, _getPrefixCls.getPrefixCls)('bubble-content'), (_clsx2 = {}, (0, _defineProperty2.default)(_clsx2, (0, _getPrefixCls.getPrefixCls)('bubble-default'), getRealType() === 'default'), (0, _defineProperty2.default)(_clsx2, (0, _getPrefixCls.getPrefixCls)('bubble-primary'), getRealType() === 'primary'), _clsx2))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx4.default)((0, _getPrefixCls.getPrefixCls)('bubble-angle'), (0, _defineProperty2.default)({}, (0, _getPrefixCls.getPrefixCls)('bubble-angle__reversed'), from === 'left'))
  }, hideBubbleAngle ? null : bubbleAngleElement), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx4.default)((0, _getPrefixCls.getPrefixCls)('bubble-real-content'))
  }, status === 'typing' ? /*#__PURE__*/_react.default.createElement("img", {
    className: (0, _getPrefixCls.getPrefixCls)('bubble-typing'),
    src: _loading_gray_slow.default
  }) : children)), showStatus && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _getPrefixCls.getPrefixCls)('bubble-status')
  }, statusElemnt || null)), ((_props$feedback = props.feedback) === null || _props$feedback === void 0 ? void 0 : _props$feedback.show) && status === 'default' && /*#__PURE__*/_react.default.createElement(_Feedback.Feedback, props.feedback));
};
exports.Bubble = Bubble;